<template>
  <div class="account tableStyle">
    <el-row>
      <el-col :span="24">
        <query
          :formData="formData"
          :formList="formList"
          @reset="resetQuery"
          @query="query"
          @clear="query"
        ></query>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-button size="small" type="primary" @click="openDialog">新增物业</el-button>
      </el-col>
    </el-row>


        <el-table :data="tableData" class="table-border" height="100%">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="name" label="物业名称"></el-table-column>
          <el-table-column prop="legal_name" label="负责人" align="center"></el-table-column>
          <el-table-column prop="legal_tel" label="联系电话" align="center"></el-table-column>
          <el-table-column prop="register_address" label="小区地址"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">待审核</span>
              <span v-else-if="scope.row.status === 1">已通过</span>
              <span v-else-if="scope.row.status === 2">已驳回</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 0">
                <el-button plain size="mini" @click="goExamine(scope.row)">审核</el-button>
              </div>
              <div v-else>
                <el-button plain size="mini" @click="goCheck(scope.row)">查看</el-button>
                <el-button plain size="mini" @click="goEdit(scope.row)">修改</el-button>
                <el-button type="danger" plain size="mini" @click="goDel(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>


    <div class="pageFoot flex">
      <div class="tongji">统计：共{{total}}个</div>
      <el-pagination
        layout="total, prev, pager, next, sizes"
        background
        :page-size="size"
        :total="total"
        :page-sizes="[20,50,100,200,500,1000]"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>
    <el-dialog top="5vh"
      :title="isExamine ? '审核物业资料' : setTitle()"
      custom-class="dialogRadius"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :before-close="closeDialog">
      <Dialog :form="form" :isExamine="isExamine" :isReadonly="isCheck" @examine="examine" @setLngLat="setLngLat" @submit="submit" @close="closeDialog"></Dialog>
    </el-dialog>
  </div>
</template>
<script>
import Query from "components/query.vue";
import Dialog from './propertyDialog.vue';
export default {
  data() {
    return {
        size: 20,
        page: 1,
        total: 0,
        allManufacturer: [],
        formData: {
            type: 2,
            name: '',
            legal_name: '',
            legal_tel: '',
            status: '',
            register_address: '',
        },
        formList: [
        //   {
        //     type: "input",
        //     label: "物业ID",
        //     placeholder: "请输入物业ID",
        //     model: "id",
        //   },
          {
            type: "input",
            label: "物业名称",
            placeholder: "请输入物业名称",
            model: "name",
            // labelName: 'name',
            // valueName: 'name',
            // optionList: []
          },
          {
            type: "input",
            label: "负责人",
            placeholder: "请输入负责人姓名",
            model: "legal_name",
          },
          {
              type: "input",
              label: "联系电话",
              placeholder: "请输入联系电话",
              model: "legal_tel",
          },
          {
              type: "select",
              label: "状态",
              placeholder: "全部",
              model: "status",
              labelName: 'label',
              valueName: 'id',
              optionList: [
                {
                  id: 0,
                  label: '待审核'
                },
                {
                  id: 1,
                  label: '已通过'
                },
                {
                  id: 2,
                  label: '已驳回'
                }
              ]
          },
          {
            type: "input",
            label: "小区地址",
            placeholder: "请输入小区地址",
            model: "register_address"
          },
        ],
        tableData: [],
        
        dialogVisible: false,
        form:{
            type: 2,
            name: '',
            legal_name: '',
            legal_tel: '',
            province_code: '',
            province_name: '',
            city_code: '',
            city_name: '',
            area_code: '',
            area_name: '',
            register_address: '',
            longitude: '',
            latitude: '',
            tel: '',
            status: 1,
        },
        isCheck: false, //查看
        isExamine: false, //审核
    };
  },
  components: {
    Query,
    Dialog
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init(){
      this.getTableList();
    //   this.getAllManufacturer();
    },
    // 获取商户列表
    getTableList(data){
      let params = {};
      if(data){
        params = data;
      }
      params.page = this.page;
      params.size = this.size;
      params.type = 2;
      this.$http.get(this.common.admin + '/admin/companyList',{
        params: params
      }).then(res => {
        if(res.code === 200){
          this.tableData = res.data.list;
          this.total = res.data.total;
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    // 获取所有物业列表
    getAllManufacturer(){
      this.$http.get(this.common.admin+'/admin/companyAllList').then(res => {
        if(res.code === 200){
          this.allManufacturer = res.data;

          for(let i of this.formList){
            if(i.label === '物业名称'){
              i.optionList = res.data;
            }
          }

        }else{
          this.$message.error(res.msg);
        }
      });
    },
    // 查询
    query(data) {
      this.page = 1;
      this.getTableList(data);
    },
    // 重置查询
    resetQuery() {
      this.page = 1;
      this.formData = {
        type: 2,
        name: '',
        legal_name: '',
        legal_tel: '',
        status: '',
        register_address: '',
      };
      this.getTableList();
    },
    // 翻页
    changePage(page){
      this.page = page;
      this.getTableList(this.formData);
    },
    sizeChange(val){
      this.size = val;
      this.getTableList(this.formData);
    },
    // 设置弹窗title
    setTitle(){
      let title = '';
      if(this.isCheck === true){
        title = '物业资料';
      }else{
        if(this.form.id){
          title = '修改物业资料';
        }else{
          title = '新建物业';
        }
      }
      return title;
    },
    // 查看物业资料
    goCheck(data){
      this.isCheck = true;
      this.goEdit(data);
    },
    // 修改物业资料
    goEdit(data){
      this.$http.get(this.common.admin + '/admin/companyDetail', {
        params: {
          id: data.id
        }
      }).then(res => {
        if(res.code === 200){
          this.form = res.data;
          this.openDialog();
        }else{
          return this.$message.error(res.msg);
        }
      });
    },
    // 删除物业
    goDel(data){
      this.$confirm(`是否确定删除${data.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(this.common.admin + '/admin/companyDelete', {
          params: {
            id: data.id
          }
        }).then(res => {
          if(res.code === 200){
            this.$message.success('删除成功');
            this.getTableList();
          }else{
            return this.$message.error(res.msg);
          }
        });
      }).catch(() => {});
    },
    // 审核
    goExamine(data){
      this.isExamine = true;
      this.isCheck = true;
      this.goEdit(data);
    },
    openDialog(){
      this.dialogVisible = true;
    },
    closeDialog(){
      this.dialogVisible = false;
      this.isCheck = false;
      this.isExamine = false;
      this.form = {
        type: 2,
        name: '',
        legal_name: '',
        legal_tel: '',
        province_code: '',
        province_name: '',
        city_code: '',
        city_name: '',
        area_code: '',
        area_name: '',
        register_address: '',
        longitude: '',
        latitude: '',
        tel: '',
        status: 1,
      }
    },
    setLngLat(data){
      this.form.register_address = data.name;
      this.form.longitude = data.lng;
      this.form.latitude = data.lat;
    },
    submit(){
      let url = '';
      // 修改
      if(this.form.id && this.form.id != ''){
        url = '/admin/companyEdit';
      }else{
        url = '/admin/companyAdd';
      }
      this.$http.post(this.common.admin + url, this.form).then(res => {
        if(res.code === 200){
          if(this.form.id && this.form.id != ''){
            this.$message.success('修改成功！');
          }else{
            this.$message.success('新增成功！');
          }
          this.closeDialog();
          this.getTableList();
        }else{
          return this.$message.error(res.msg);
        }
      });
    },
    examine(data){
      this.$http.get(this.common.admin + '/admin/companyChangeStatus', {
        params : {
          id: this.form.id,
          status: data
        }
      }).then(res => {
        if(res.code === 200){
          if(data === 1){
            this.$message.success('通过审核');
          }else{
            this.$message.info('已驳回');
          }
          this.closeDialog();
          this.getTableList();
        }else{
          return this.$message.error(res.msg);
        }
      });
    }
  },
};
</script>
<style lang="less" scoped>
.account {
  height: 100%;
  display: flex;
  flex-direction: column;

  // .tableArea{
  //   // flex: 1;
  //   height: calc(100% - 184px);
  //   overflow: auto;
  // }
  /deep/.dialogRadius{
    min-width: 1000px;
    width: 60%;
  }
  .pageFoot{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tongji{
      font-size: 14px;
    }
  }
}
</style>